import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<g stroke="none"><path fill-rule="evenodd" d="M16.758 6.765c.351.17.576.536.576.939v16.592c0 .403-.225.769-.576.94a.972.972 0 0 1-1.065-.143l-5.722-4.945H6.333c-.552 0-1-.464-1-1.037V12.89c0-.573.448-1.037 1-1.037h3.638l5.722-4.945a.972.972 0 0 1 1.065-.142Z" clip-rule="evenodd"></path><path fill-rule="evenodd" d="M19.426 13.971h-.002a1 1 0 1 1 .486-1.94c.633.157 1.305.694 1.793 1.313.516.656.964 1.576.964 2.656s-.448 2-.964 2.656c-.488.619-1.16 1.156-1.793 1.314a1 1 0 0 1-.486-1.94l.002-.001c.016-.007.099-.041.235-.143a2.61 2.61 0 0 0 .47-.467c.317-.403.536-.9.536-1.419 0-.52-.219-1.016-.536-1.419a2.61 2.61 0 0 0-.47-.467 1.102 1.102 0 0 0-.235-.143Z" clip-rule="evenodd"></path></g>';
export var VolumeMidSVG = function VolumeMidSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
VolumeMidSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(VolumeMidSVG);